import React from 'react';
import { bem, getDataAttr } from '../_libs/utils';
import { Component, PropTypes } from '../_libs';

export default class CardContent extends Component {

  render() {
    const displayName = 'card__content';
    const { children } = this.props;

    return (
      <div className={this.className(bem(displayName))} style={this.style()} {...getDataAttr(this.props)}>
        {children}
      </div>
    );
  }
}

CardContent.defaultProps = {
  children: '',
};

CardContent.propTypes = {
  // @INTRO 设置子节点
  children: PropTypes.node,
};

